import toDate from'../toDate/index.js';import toInteger from'../_lib/toInteger/index.js';import requiredArgs from'../_lib/requiredArgs/index.js';/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */export default function startOfWeek(dirtyDate,dirtyOptions){requiredArgs(1,arguments);var options=dirtyOptions||{};var locale=options.locale;var localeWeekStartsOn=locale&&locale.options&&locale.options.weekStartsOn;var defaultWeekStartsOn=localeWeekStartsOn==null?0:toInteger(localeWeekStartsOn);var weekStartsOn=options.weekStartsOn==null?defaultWeekStartsOn:toInteger(options.weekStartsOn);// Test if weekStartsOn is between 0 and 6 _and_ is not NaN
if(!(weekStartsOn>=0&&weekStartsOn<=6)){throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');}var date=toDate(dirtyDate);var day=date.getDay();var diff=(day<weekStartsOn?7:0)+day-weekStartsOn;date.setDate(date.getDate()-diff);date.setHours(0,0,0,0);return date;}